import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import { useFormik } from "formik";
import { getLocalStorageItem } from "../../utils/localStorage";
import {
  initialSwiftDetails,
  nextOfKinRelationships,
  statesInNigeria,
} from "../../utils/constants";
import Loader from "../Loader";
import CustomInputField from "../CustomInputField/CustomInputField";
import CustomDropdown from "../CustomDropdown";
import SectionLabel from "../SectionLabel";
import FormHelperText from "../FormHelperText";
import {
  extractValuesFromObj,
  isEmptyObj,
  returnInputErrorMessage,
  returnLgaError,
} from "../../utils/helpers";
import { swiftDetailsValidationSchema } from "../../utils/validationSchemas";
import apiHooks from "../../customHooks/apis";
import { SwiftSavingsDetails } from "../../types/swiftSavings";
import useAutoUpdateAddress from "../../customHooks/useAutoUpdateAddress";

function UpdateDetailSwiftSavingsDialog(props: any) {
  const dispatch = useDispatch();
  const {
    useGetEmploymentInfo,
    useGetRelationships,
    useGetBranchCodes,
    useGetSocialMediaTypes,
    useGetReligions,
    useGetOccupations,
    useUploadDomDetails,
    useUserDetails,
  } = apiHooks;
  const { employmentInfo, getSelectedEmployment } = useGetEmploymentInfo();
  const {} = useGetRelationships();
  const { branches, getSelectedBranch } = useGetBranchCodes();
  const { socialMedia, getSocialMedia } = useGetSocialMediaTypes();
  const { religions, getSelectedReligion } = useGetReligions();
  const { occupations, getSelectedOccupation } = useGetOccupations();
  const { handleUpdateUserDetails } = useUserDetails();

  const { handleSubmitDomDetails, postingDomDetails, userDetails } =
    useUploadDomDetails();
  const [otpLoader] = useState(false);
  const [genders] = useState<any[]>([
    { name: "Male", value: "M" },
    { name: "Female", value: "F" },
  ]);
  const [lgas, setLgas] = useState([]);

  const goToStep = (step: any) => {
    handleUpdateUserDetails({
      ...formik.values,
      email: formik.values.emailAddress,
    });
    dispatch(setAccountOpeningStep(step));
  };

  const formik = useFormik<SwiftSavingsDetails>({
    initialValues: {
      ...initialSwiftDetails,
    },
    validationSchema: swiftDetailsValidationSchema,
    validateOnBlur: true,
    validateOnMount: true,
    onSubmit: (values) => {
      handleSubmitDomDetails({
        ...values,
        employmentInformation: `${values.employmentInformation}`,
        gender: values.gender[0],
      });
    },
  });
  useAutoUpdateAddress<SwiftSavingsDetails>({
    formik,
    fieldNames: [
      "houseNumber",
      "streetName",
      "nearestBustopLandmark",
      "areaState",
    ],
  });
  // const handleBlurAddressChild = (
  //   event: React.FocusEvent<HTMLInputElement | HTMLSelectElement>
  // ) => {
  //   const { name } = event.target;
  //   formik.setValues({
  //     ...formik.values,
  //     address:
  //       `${formik.values?.houseNumber} ${formik.values?.streetName} ${formik.values?.nearestBustopLandmark} ${formik.values?.areaState}`.trim(),
  //   });
  //   formik.setFieldTouched(name, true);
  // };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const charCode = event.which || event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  };

  const handleStateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = event.target.value;
    const state = statesInNigeria.find((state) => state.name === selected);
    if (state) {
      setLgas(state.lgas);
    } else {
      setLgas([]);
    }
    formik.handleChange(event);
  };

  useEffect(() => {
    formik.setValues(
      {
        ...initialSwiftDetails,
        ...extractValuesFromObj(initialSwiftDetails, userDetails),
        dob: userDetails?.dateOfBirth,
        emailAddress: userDetails?.email || "",
        nextOfKin: userDetails?.nameOfNextOfKin || userDetails.nextOfKin || "",
      },
      true
    );
  }, [userDetails]);

  return (
    <div>
      {otpLoader && <Loader />}
      <div className=" card-form pl-1 pr-1 ">
        <form
          onSubmit={formik.handleSubmit}
          className="update-details-form-body"
        >
          <div className="card-body">
            <h4 className="card-title text-center pl-3 mt-4">Update details</h4>
            <p className="text-center pl-5 no-wrap">
              Hello{" "}
              <span className="font-weight-bold">
                <b>{userDetails?.firstName},</b>{" "}
              </span>
              Welcome to The Alternative Bank
            </p>
            <FormHelperText />
            <div className="row">
              <div className="col mt-4 pt-2 sec">
                <div className="row form-row mb-3">
                  <div className="col-lg-6 sec">
                    <label htmlFor="firstname" className="label_text">
                      First name
                    </label>
                    <input
                      name="firstName"
                      value={userDetails?.firstName}
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder="Tunde"
                      disabled
                    />
                  </div>

                  <div className="col-lg-6">
                    <label htmlFor="secondname" className="label_text">
                      Middle name
                    </label>
                    <input
                      name="secondName"
                      value={userDetails?.middleName}
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder=""
                      disabled
                    />
                  </div>
                </div>

                <div className="row form-row mb-3">
                  <div className="col-lg-6">
                    <label htmlFor="lastname" className="label_text">
                      Surname
                    </label>
                    <input
                      name="lastName"
                      value={userDetails?.lastName}
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder="Aminah"
                      disabled
                    />
                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="dateofbirth" className="label_text">
                      Date of birth
                    </label>
                    <input
                      name="dateOfBirth"
                      value={
                        userDetails?.dateOfBirth ||
                        getLocalStorageItem("deb")?.dob
                      }
                      type="text"
                      className="form-control bg-white border-dark"
                      placeholder="12-04-1989"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col sec">
                <div className="row form-row mb-3">
                  <div className="col-lg-6">
                    <label htmlFor="gender" className="label_text">
                      Gender
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <select
                      name="gender"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.gender}
                      disabled
                      className="form-control border-dark"
                      style={{
                        padding: "13px",
                      }}
                      id="gender"
                    >
                      <option value="">
                        {formik.values.gender || "Select a gender"}
                      </option>
                      {genders.map((gender: any) => {
                        return (
                          <option key={gender.name} value={gender.value}>
                            {gender.name}
                          </option>
                        );
                      })}
                    </select>
                    {formik.touched.gender && formik.errors.gender ? (
                      <small className="text-danger">
                        {formik.errors.gender}
                      </small>
                    ) : null}
                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="dateofbirth" className="label_text">
                      Email address
                    </label>
                    <input
                      name="emailAddress"
                      onChange={formik.handleChange}
                      value={formik.values.emailAddress}
                      onBlur={formik.handleBlur}
                      className="form-control bg-white border-dark"
                      placeholder=""
                    />
                    {formik.touched.emailAddress &&
                    formik.errors.emailAddress ? (
                      <small className="text-danger">
                        {formik.errors.emailAddress}
                      </small>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            <SectionLabel label="Residential address" />

            <div className="col sec">
              <div className="row form-row mb-3">
                <div className="col-lg-6 mr-2">
                  <label htmlFor="housenumber" className="label_text">
                    House number<span className="text-danger">*</span>
                  </label>
                  <input
                    name="houseNumber"
                    onChange={formik.handleChange}
                    value={formik.values.houseNumber}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    onKeyPress={handleKeyPress}
                    className="form-control bg-white border-dark"
                    placeholder="eg. 12"
                    pattern="[0-9]*"
                  />
                  {formik.touched.houseNumber && formik.errors.houseNumber ? (
                    <small className="text-danger">
                      {formik.errors.houseNumber}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="streetname" className="label_text">
                    Street name <span className="text-danger">*</span>
                  </label>
                  <input
                    name="streetName"
                    onChange={formik.handleChange}
                    value={formik.values.streetName}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Bode Thomas"
                  />
                  {formik.touched.streetName && formik.errors.streetName ? (
                    <small className="text-danger">
                      {formik.errors.streetName}
                    </small>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="col sec">
              <div className="row form-row mb-3 align-items-end">
                <div className="col-lg-6">
                  <CustomInputField
                    required
                    label="Nearest bus-stop/landmark"
                    name="nearestBustopLandmark"
                    onChange={formik.handleChange}
                    value={formik.values.nearestBustopLandmark}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Masha round about"
                    errorMessage={
                      returnInputErrorMessage<typeof formik.initialValues>(
                        formik,
                        "nearestBustopLandmark"
                      ) as string
                    }
                  />
                </div>
                <div className="col-lg-6 mr-2">
                  <CustomDropdown
                    label="State"
                    required
                    name="areaState"
                    onClickOption={handleStateChange}
                    value={formik.values.areaState}
                    // onBlur={handleBlurAddressChild}
                    placeholder="Select state"
                    options={statesInNigeria}
                    labelKey="name"
                    valueKey="name"
                    errorMessage={returnInputErrorMessage<SwiftSavingsDetails>(
                      formik,
                      "areaState"
                    )}
                    formik={formik}
                  />

                  {/* <select
                    className="form-control border-dark"
                    style={{
                      padding: "13px",
                    }}
                  >
                    <option value=""></option>
                    {statesInNigeria.map((state: any) => {
                      return (
                        <option key={state.name} value={state.name}>
                          {state.name}
                        </option>
                      );
                    })}
                  </select> */}
                  {/* {formik.touched.areaState && formik.errors.areaState ? (
                    <small className="text-danger">
                      {formik.errors.areaState}
                    </small>
                  ) : null} */}
                </div>
              </div>
            </div>

            <div className="col sec">
              <div className="row form-row mb-3 align-items-end">
                <div className="col-lg-6 mr-2">
                  <CustomDropdown
                    label="Local Government Area (L.G.A)"
                    required
                    name="localGovernment"
                    onClickOption={formik.handleChange}
                    value={formik.values.localGovernment}
                    // onBlur={handleBlurAddressChild}
                    placeholder="Select LGA"
                    options={lgas}
                    errorMessage={returnLgaError({
                      stateError: returnInputErrorMessage<SwiftSavingsDetails>(
                        formik,
                        "areaState"
                      ),
                      lgaError: returnInputErrorMessage<SwiftSavingsDetails>(
                        formik,
                        "localGovernment"
                      ),
                    })}
                    formik={formik}
                  />
                </div>
                <div className="col-lg-6">
                  <CustomInputField
                    required
                    label="Town"
                    name="town"
                    onChange={formik.handleChange}
                    value={formik.values.town}
                    // onBlur={handleBlurAddressChild}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="Enter your town"
                    errorMessage={
                      returnInputErrorMessage<typeof formik.initialValues>(
                        formik,
                        "town"
                      ) as string
                    }
                  />
                </div>
              </div>
            </div>

            <div className="form-group mb-4">
              <label htmlFor="address" className="label_text">
                Enter full address<span className="text-danger">*</span>
              </label>
              <input
                name="address"
                onChange={formik.handleChange}
                value={formik.values.address}
                onBlur={formik.handleBlur}
                className="form-control sec border-dark"
                type="text"
                id="address"
                placeholder="No 12 Bode Thomas Masha round about Lagos"
                readOnly
              />
              {formik.touched.address && formik.errors.address ? (
                <small className="text-danger">{formik.errors.address}</small>
              ) : null}
            </div>

            <SectionLabel label="Other Information" />

            <div className="row form-row mb-3">
              <CustomInputField
                required
                name="nextOfKin"
                label="Name of next of kin"
                placeholder="Enter name of next of kin"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.nextOfKin}
                errorMessage={
                  returnInputErrorMessage<typeof formik.initialValues>(
                    formik,
                    "nextOfKin"
                  ) as string
                }
              />
            </div>
            <div className="row form-row mb-3">
              <CustomDropdown
                required
                extraClasses="col-lg-6 mt-2"
                label="Relationship to next of kin"
                options={nextOfKinRelationships}
                name="relationshipOfNextOfKin"
                onClickOption={formik.handleChange}
                errorMessage={
                  returnInputErrorMessage<typeof formik.initialValues>(
                    formik,
                    "relationshipOfNextOfKin"
                  ) as string
                }
                value={formik.values.relationshipOfNextOfKin}
                formik={formik}
              />
              <CustomDropdown
                required
                extraClasses="col-lg-6 mt-2"
                label="Religion"
                name="religion"
                labelKey="religion"
                valueKey="id"
                onClickOption={formik.handleChange}
                value={getSelectedReligion(formik.values.religion as number)}
                options={religions}
                formik={formik}
                errorMessage={returnInputErrorMessage<
                  typeof formik.initialValues
                >(formik, "religion")}
              />
            </div>
            <div className="row form-row mb-3">
              <CustomDropdown
                required
                name="employmentInformation"
                label="Select employment information"
                extraClasses="col-lg-6"
                onClickOption={formik.handleChange}
                formik={formik}
                value={getSelectedEmployment(
                  +formik.values.employmentInformation
                )}
                errorMessage={returnInputErrorMessage<
                  typeof formik.initialValues
                >(formik, "employmentInformation")}
                options={employmentInfo}
                labelKey="name"
                valueKey="id"
              />
              <CustomDropdown
                required
                label="Occupation"
                name="occupation"
                onClickOption={formik.handleChange}
                value={getSelectedOccupation(
                  formik.values.occupation as number
                )}
                extraClasses="col-lg-6 mr-0"
                className="form-control border-dark"
                onBlur={formik.handleBlur}
                placeholder="Select occupation"
                errorMessage={returnInputErrorMessage<
                  typeof formik.initialValues
                >(formik, "occupation")}
                options={occupations}
                labelKey="name"
                valueKey="id"
                formik={formik}
              />
            </div>
            <div className="col sec">
              <div className="row form-row mb-3 align-items-end">
                <div className="col-lg-6 mr-2">
                  <CustomDropdown
                    label="Social media type"
                    name="socialMediaId"
                    onChange={formik.handleChange}
                    value={getSocialMedia(
                      formik.values.socialMediaId as number
                    )}
                    className="form-control border-dark"
                    style={{ paddingTop: "12px", paddingBottom: "12px" }}
                    options={socialMedia}
                    placeholder="--Choose one--"
                    labelKey="name"
                    valueKey="id"
                  />
                  {formik.touched.socialMediaId &&
                  formik.errors.socialMediaId ? (
                    <small className="text-danger">
                      {formik.errors.socialMediaId}
                    </small>
                  ) : null}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="socialMediaHandle" className="label_text">
                    Enter social media link/handle
                  </label>
                  <input
                    name="socialMediaHandle"
                    onChange={formik.handleChange}
                    value={formik.values.socialMediaHandle}
                    type="text"
                    className="form-control bg-white border-dark"
                    placeholder="@john_doe"
                  />
                  {formik.touched.socialMediaHandle &&
                  formik.errors.socialMediaHandle ? (
                    <small className="text-danger">
                      {formik.errors.socialMediaHandle}
                    </small>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="row form-row mb-3 align-items-end">
              <CustomDropdown
                required
                extraClasses="col-lg-6"
                label="Branch of Domiciliation"
                placeholder="Select"
                name="branchOfDomiciliation"
                value={getSelectedBranch(
                  formik.values.branchOfDomiciliation as string
                )}
                formik={formik}
                options={branches}
                labelKey="branch"
                valueKey="brancH_CODE"
                errorMessage={returnInputErrorMessage<
                  typeof formik.initialValues
                >(formik, "branchOfDomiciliation")}
                onClickOption={formik.handleChange}
              />
              <div className="form-group col-lg-6">
                <label htmlFor="refferalcode" className="label_text">
                  DAO/Referral code(optional)
                </label>
                <input
                  name="referralCode"
                  onChange={formik.handleChange}
                  value={formik.values.referralCode}
                  className="form-control border-dark"
                  type="text"
                  id="name"
                  placeholder="Enter referral code"
                />
              </div>
            </div>

            <div>
              <div className="d-flex justify-content-end mt-4">
                <button
                  onClick={() => {
                    goToStep("bvn-validation");
                  }}
                  style={{ marginRight: "10px" }}
                  className="btn btn-outline-gold btn-filled-white"
                  type="button"
                >
                  Previous
                </button>
                {postingDomDetails ? (
                  <div className="spinner-border text-gold" role="status">
                    <span className="sr-only"></span>
                  </div>
                ) : (
                  <button
                    type="submit"
                    className="btn btn-filled-red"
                    disabled={!formik.isValid}
                  >
                    Proceed
                  </button>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UpdateDetailSwiftSavingsDialog;
